import { styled } from '@mui/material/styles';

export const ActionWrapper = styled('div')`
  display: flex;
  justify-content: space-between;
  margin: 1rem 0;
`;
